import React from "react";
import { observer } from "mobx-react";
import { injectFromAppUpload } from "../inject";
import { FileSelectionComponent } from "./file-selection/FileSelectionComponent";
import { DragAndDropComponent } from "./DragAndDropComponent";
import { PatientsUploadComponent } from "./verify-patient-study/PatientsUploadComponent";
import { UploadCodeAndSourceSelectionComponent } from "./upload-code-and-source-selection/UploadCodeAndSourceSelectionComponent";
import type { IUploadCodeAndSourceSelectionStore } from "./upload-code-and-source-selection/UploadCodeAndSourceSelectionStore";
import { fireAndForget } from "../../util/async/FireAndForget";

interface IUploadContentComponentProps {
    uploadCodeAndSourceSelectionStore?: IUploadCodeAndSourceSelectionStore;
}

@injectFromAppUpload<IUploadContentComponentProps>((stores) => ({
    uploadCodeAndSourceSelectionStore: stores.uploadCodeAndSourceSelectionStore,
}))

@observer
export class UploadContentComponent extends React.Component<IUploadContentComponentProps> {
    
    componentDidMount() {
        const { uploadCodeAndSourceSelectionStore } = this.props;
        if (uploadCodeAndSourceSelectionStore!.ableToValidateCodeAndSource) {
            fireAndForget(uploadCodeAndSourceSelectionStore!.validateCodeAndSource());
        }
    }
    
    render() {
        const { uploadCodeAndSourceSelectionStore } = this.props;
        const { uploadCodeAndSourceValid } = uploadCodeAndSourceSelectionStore!;

        // @ts-ignore
        return (
            <div id={"upload-content"}>
                <DragAndDropComponent>
                    <UploadCodeAndSourceSelectionComponent />
                    {uploadCodeAndSourceValid && (
                        <div id={"upload-components"}>
                            <FileSelectionComponent />
                            <PatientsUploadComponent />
                        </div>
                    )}
                </DragAndDropComponent>
            </div>
        );
    }
}
